import { Injectable, EventEmitter, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { BehaviorSubject } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import sha256 from 'crypto-js/sha256';

import { CustomProffixService } from './custom-proffix.service';
import { PxRestConfig } from './models';
import {
  Configuration, ConnectionSettings, ConnectionSettingsService,
  Login, LoginService, Mitarbeiter, Datenbank, DatenbankService
} from '@proffix/restapi-angular-library';

@Injectable()
export class UserSessionService {
  private _pxRestConfig: PxRestConfig;
  private _proffixLogin$ = new BehaviorSubject<Login>(null);
  private _connectionSettings: ConnectionSettings;

  constructor(
    private _configuration: Configuration,
    private _connectionSettingsService: ConnectionSettingsService,
    private _loginService: LoginService,
    private _datenbankService: DatenbankService,
    private _customProffixService: CustomProffixService,
    private _http: Http,
  ) {

    this._loginService.loginFailedObservable.subscribe(() => {
      this.updateProffixLogin(null);
    });
  }

  public sendLogin(user: string, password: string): Observable<Login> {
    return Observable.create(observer => {

      // read the webservice configuration
      this._http.get('assets/px-rest.config.json')
        .map(res => res.json())
        .toPromise()
        .then((config: PxRestConfig) => {
          this._pxRestConfig = config;

          this._connectionSettings = {
            WebserviceUrl: this._pxRestConfig.WebserviceUrl,
            WebservicePasswortHash: this._pxRestConfig.WebservicePasswortHash,
          };

          this._connectionSettingsService.current = this._connectionSettings;

          const login = {
            Benutzer: user, // 'REST',
            Passwort: sha256(password).toString(), // 'b251727a5cb7e1472ed74f56707e48e216ce834e6ef3db19a686450d7aca0e93',
            Datenbank: {
              Name: this._pxRestConfig.Datenbank,
            },
            Module: this._configuration.getRequiredLicencedModulesAsStringArray()
          };

          this._loginService.activateAutoLogin(login);

          this._loginService.doLogin().subscribe(
            (result) => {
              this.updateProffixLogin(result);
              observer.next(result);
              observer.complete();
            },
            (error) => {
              // error
              this.updateProffixLogin(null);
              observer.error(error);
            });

        });
    });
  }

  public checkLogin() {
    this._customProffixService.getLogin().subscribe(
      (result) => {
        // success (already logged in)
        this.updateProffixLogin(result);
      },
      () => {
        //this._loginService.removeAutoLogin();
        /*
        this._loginService.doLogin().subscribe(
          (result) => {
            // success
            this.updateProffixLogin(result);
          },
          () => {
            // login not successfull: Delete session
            this.logout();
          });
          */
      });
  }

  public logout(): Observable<void> {
    return Observable.create(observer => {
      this._loginService.removeAutoLogin();
      this.updateProffixLogin(null);

      this._loginService.doLogout().finally(() => {
        console.log("finally doLogout()");
        observer.complete();
      }).subscribe(() => { console.log("finally subscribe()"); }, (err) => { alert(err); });
    });
  }

  public handleRequest<T>(apiRequest: ApiRequest<T>): Observable<T> {
    return Observable.create(observer => {
      // run the api request
      apiRequest().subscribe((a) => {
        console.log("Result in UserSessionService.handleRequest: " + a);
        
        observer.next(a);
        observer.complete();
      }, (error) => {
        console.log("Error in UserSessionService.handleRequest: " + error);

        // something went wrong - check the login state
        this.checkLogin();
        observer.error(error);
      });
    });
  }

  getProffixLogin(): BehaviorSubject<Login> {
    return this._proffixLogin$;
  }

  updateProffixLogin(value: Login): void {
    this._proffixLogin$.next(value);
  }

  public isManager(): boolean {
    if (this._proffixLogin$.value
      && this._proffixLogin$.value.Mitarbeiter
      && this._proffixLogin$.value.Mitarbeiter.Zusatzfelder
      && this._proffixLogin$.value.Mitarbeiter.Zusatzfelder.Z_Zeitmanagement_Rolle === 'Manager') {
      return true;
    }

    return false;
  }

  public isTeamleiter(): boolean {
    if (this._proffixLogin$.value
      && this._proffixLogin$.value.Mitarbeiter
      && this._proffixLogin$.value.Mitarbeiter.Zusatzfelder
      && this._proffixLogin$.value.Mitarbeiter.Zusatzfelder.Z_Zeitmanagement_Rolle === 'Teamleiter') {
      return true;
    }

    return false;
  }

  public isMitarbeiterWithAnyRole(mitarbeiter: Mitarbeiter): boolean {
    return this.isMitarbeiterWithManagerRole(mitarbeiter) || this.isMitarbeiterWithTeamleiterRole(mitarbeiter) || this.isMitarbeiterWithMitarbeiterRole(mitarbeiter);
  }

  public isMitarbeiterWithManagerRole(mitarbeiter: Mitarbeiter): boolean {
    if (mitarbeiter
      && mitarbeiter.Zusatzfelder
      && mitarbeiter.Zusatzfelder.Z_Zeitmanagement_Rolle === 'Manager') {
      return true;
    }

    return false;
  }

  public isMitarbeiterWithTeamleiterRole(mitarbeiter: Mitarbeiter): boolean {
    if (mitarbeiter
      && mitarbeiter.Zusatzfelder
      && mitarbeiter.Zusatzfelder.Z_Zeitmanagement_Rolle === 'Teamleiter') {
      return true;
    }

    return false;
  }

  public isMitarbeiterWithMitarbeiterRole(mitarbeiter: Mitarbeiter): boolean {
    if (mitarbeiter
      && mitarbeiter.Zusatzfelder
      && mitarbeiter.Zusatzfelder.Z_Zeitmanagement_Rolle === 'Mitarbeiter') {
      return true;
    }

    return false;
  }
}

export type ApiRequest<T> = () => Observable<T>;



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/services/user-session.service.ts